import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["select", "otherField", "otherInput"]

    connect() {
        this.toggle()
    }

    toggle() {
        const isOther = this.selectTarget.value === "Autre motif"

        this.otherFieldTarget.classList.toggle("is-hidden", !isOther)
        this.otherInputTarget.disabled = !isOther

        if (!isOther) {
            this.otherInputTarget.value = ""
        }
    }
}
